import React from 'react';

import { Container, Row, Col } from 'reactstrap';

import Version from 'ui/Version/Version';

const Footer = () => (
   <footer className='footer d-print-none'>
      <Container fluid>
         <Row className='text-muted'>
            <Col xs='6' className='text-left'>
               <ul className='list-inline'>
                  <li className='list-inline-item'>
                     <a className='text-muted' href='/t/help'>
                        Help Center
                     </a>
                  </li>
                  <li className='list-inline-item'>
                     {/* local TermsPage route (ungated) — the AOE /help/terms URL dies with DE (A-5) */}
                     <a className='text-muted' href='/t/employer/help/terms' target='_blank'>
                        Terms of Service
                     </a>
                  </li>
               </ul>
            </Col>
            <Col xs='6' className='text-right'>
               <p className='mb-0'>
                  &copy;
                  {new Date().getFullYear()}
                  {' '}
                  -
                  {' '}
                  <a href='/' className='text-muted'>
                     Upward.net
                  </a>
                  <Version/>
               </p>
            </Col>
         </Row>
      </Container>
   </footer>
);

export default Footer;
